
import cartMixin from '@/mixins/cartMixin.js';
export default {
  mixins: [cartMixin],
  computed: {
    totalProductQuantity() {
      return this.cart?.Total?.Product?.Quantity;
    },
    totalToPay() {
      return this.cart?.Total?.ToPay?.TaxIncl;
    },
    productTotalToPay() {
      return this.cart?.Total?.Product?.TaxIncl;
    },
    totalDiscount() {
      return this.cart?.Total?.Discount?.TaxIncl;
    },
    currencySign() {
      return this.$localisation.currencySign;
    },
    isGuest() {
      const guestUser = this.$auth.user?.Customer?.Guest;
      return !this.$auth.loggedIn || guestUser;
    },
    earnPoints() {
      return (this.totalToPay || 0).toFixed(0);
    },
  },
};
